import React, { useState } from 'react';
import './YouTubeVideo.css';

const YouTubeVideo = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <section className="youtube-video section">
      {/* Top Section - Prime Video Info */}
      <div className="top-section">
        <div className="prime-video-info">
          <img src="/home_data/section5/logo.png" alt="Prime Video" className="prime-logo" />
        </div>
        <div className="series-title">
          <img src="/home_data/section5/Group 529.png" alt="Prime Video" className="series-title-image" />
        </div>
      </div>
      <div style={{marginTop: '20px'}}>
        <iframe
          style={{ marginLeft: '10vw', width: '79vw', height: '80vh' }}
          src="https://www.youtube.com/embed/PKehFiyf9_I?autoplay=0"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

export default YouTubeVideo;
